/**
 * The parent shell.
 *
 * One thing this shell can never do, by construction: show a conversation. No
 * component here renders session events, no route reaches `/api/sessions`, and
 * `core-api` would refuse a parent anyway (`Child` dependency). Confidentiality
 * is not a display rule that a future screen could forget — there is no data
 * path to forget it on.
 *
 * La barre du haut vit dans `ParentTopNav` depuis le 6 septembre 2026 : les
 * réglages la partagent, pour qu'ils soient un onglet et non une sortie.
 */

import { Outlet } from "react-router-dom";

import { ParentTopNav } from "@/parent/ParentTopNav";

export function ParentShell() {
  return (
    <div className="shell shell--parent">
      <ParentTopNav />
      <div className="shell__body">
        <Outlet />
      </div>
    </div>
  );
}
